export interface Country {
  id: string;
  name: string;
  flagCountryCode?: string;
  flagEmoji?: string;
  currency: string;
}

export const CurrencyFlagCountryCodes: Record<string, string> = {
  AUD: 'AU',
  CHF: 'CH',
  DKK: 'DK',
  EUR: 'EU',
  GBP: 'GB',
  ILS: 'IL',
  NZD: 'NZ',
  USD: 'US',
  XAF: 'UN',
  XCD: 'UN',
  XOF: 'UN',
  XPF: 'UN',
};

export const CountriesWithCurrencies: Country[] = [
  {id: 'AD', name: 'Andorra', currency: 'EUR'},
  {id: 'AE', name: 'United Arab Emirates', currency: 'AED'},
  {id: 'AF', name: 'Afghanistan', currency: 'AFN'},
  {id: 'AG', name: 'Antigua and Barbuda', currency: 'XCD'},
  {id: 'AI', name: 'Anguilla', currency: 'XCD'},
  {id: 'AL', name: 'Albania', currency: 'ALL'},
  {id: 'AM', name: 'Armenia', currency: 'AMD'},
  {id: 'AO', name: 'Angola', currency: 'AOA'},
  {id: 'AQ', name: 'Antarctica', currency: 'XCD'},
  {id: 'AR', name: 'Argentina', currency: 'ARS'},
  {id: 'AS', name: 'American Samoa', currency: 'USD'},
  {id: 'AT', name: 'Austria', currency: 'EUR'},
  {id: 'AU', name: 'Australia', currency: 'AUD'},
  {id: 'AW', name: 'Aruba', currency: 'AWG'},
  {id: 'AX', name: 'Åland', currency: 'EUR'},
  {id: 'AZ', name: 'Azerbaijan', currency: 'AZN'},
  {id: 'BA', name: 'Bosnia and Herzegovina', currency: 'BAM'},
  {id: 'BB', name: 'Barbados', currency: 'BBD'},
  {id: 'BD', name: 'Bangladesh', currency: 'BDT'},
  {id: 'BE', name: 'Belgium', currency: 'EUR'},
  {id: 'BF', name: 'Burkina Faso', currency: 'XOF'},
  {id: 'BG', name: 'Bulgaria', currency: 'BGN'},
  {id: 'BH', name: 'Bahrain', currency: 'BHD'},
  {id: 'BI', name: 'Burundi', currency: 'BIF'},
  {id: 'BJ', name: 'Benin', currency: 'XOF'},
  {id: 'BL', name: 'Saint Barthélemy', currency: 'EUR'},
  {id: 'BM', name: 'Bermuda', currency: 'BMD'},
  {id: 'BN', name: 'Brunei', currency: 'BND'},
  {id: 'BO', name: 'Bolivia', currency: 'BOB'},
  {id: 'BQ', name: 'Bonaire', currency: 'USD'},
  {id: 'BR', name: 'Brazil', currency: 'BRL'},
  {id: 'BS', name: 'Bahamas', currency: 'BSD'},
  {id: 'BT', name: 'Bhutan', currency: 'BTN'},
  {id: 'BV', name: 'Bouvet Island', currency: 'NOK'},
  {id: 'BW', name: 'Botswana', currency: 'BWP'},
  {id: 'BY', name: 'Belarus', currency: 'BYN'},
  {id: 'BZ', name: 'Belize', currency: 'BZD'},
  {id: 'CA', name: 'Canada', currency: 'CAD'},
  {id: 'CC', name: 'Cocos [Keeling] Islands', currency: 'AUD'},
  {
    id: 'CD',
    name: 'Democratic Republic of the Congo',
    currency: 'CDF',
  },
  {id: 'CF', name: 'Central African Republic', currency: 'XAF'},
  {id: 'CG', name: 'Republic of the Congo', currency: 'XAF'},
  {id: 'CH', name: 'Switzerland', currency: 'CHF'},
  {id: 'CI', name: 'Ivory Coast', currency: 'XOF'},
  {id: 'CK', name: 'Cook Islands', currency: 'NZD'},
  {id: 'CL', name: 'Chile', currency: 'CLP'},
  {id: 'CM', name: 'Cameroon', currency: 'XAF'},
  {id: 'CN', name: 'China', currency: 'CNY'},
  {id: 'CO', name: 'Colombia', currency: 'COP'},
  {id: 'CR', name: 'Costa Rica', currency: 'CRC'},
  {id: 'CU', name: 'Cuba', currency: 'CUP'},
  {id: 'CV', name: 'Cape Verde', currency: 'CVE'},
  {id: 'CW', name: 'Curacao', currency: 'ANG'},
  {id: 'CX', name: 'Christmas Island', currency: 'AUD'},
  {id: 'CY', name: 'Cyprus', currency: 'EUR'},
  {id: 'CZ', name: 'Czech Republic', currency: 'CZK'},
  {id: 'DE', name: 'Germany', currency: 'EUR'},
  {id: 'DJ', name: 'Djibouti', currency: 'DJF'},
  {id: 'DK', name: 'Denmark', currency: 'DKK'},
  {id: 'DM', name: 'Dominica', currency: 'XCD'},
  {id: 'DO', name: 'Dominican Republic', currency: 'DOP'},
  {id: 'DZ', name: 'Algeria', currency: 'DZD'},
  {id: 'EC', name: 'Ecuador', currency: 'USD'},
  {id: 'EE', name: 'Estonia', currency: 'EUR'},
  {id: 'EG', name: 'Egypt', currency: 'EGP'},
  {id: 'EH', name: 'Western Sahara', currency: 'MAD'},
  {id: 'ER', name: 'Eritrea', currency: 'ERN'},
  {id: 'ES', name: 'Spain', currency: 'EUR'},
  {id: 'ET', name: 'Ethiopia', currency: 'ETB'},
  {id: 'FI', name: 'Finland', currency: 'EUR'},
  {id: 'FJ', name: 'Fiji', currency: 'FJD'},
  {id: 'FK', name: 'Falkland Islands', currency: 'FKP'},
  {id: 'FM', name: 'Micronesia', currency: 'USD'},
  {id: 'FO', name: 'Faroe Islands', currency: 'DKK'},
  {id: 'FR', name: 'France', currency: 'EUR'},
  {id: 'GA', name: 'Gabon', currency: 'XAF'},
  {id: 'GB', name: 'United Kingdom', currency: 'GBP'},
  {id: 'GD', name: 'Grenada', currency: 'XCD'},
  {id: 'GE', name: 'Georgia', currency: 'GEL'},
  {id: 'GF', name: 'French Guiana', currency: 'EUR'},
  {id: 'GG', name: 'Guernsey', currency: 'GBP'},
  {id: 'GH', name: 'Ghana', currency: 'GHS'},
  {id: 'GI', name: 'Gibraltar', currency: 'GIP'},
  {id: 'GL', name: 'Greenland', currency: 'DKK'},
  {id: 'GM', name: 'Gambia', currency: 'GMD'},
  {id: 'GN', name: 'Guinea', currency: 'GNF'},
  {id: 'GP', name: 'Guadeloupe', currency: 'EUR'},
  {id: 'GQ', name: 'Equatorial Guinea', currency: 'XAF'},
  {id: 'GR', name: 'Greece', currency: 'EUR'},
  {
    id: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    currency: 'GBP',
  },
  {id: 'GT', name: 'Guatemala', currency: 'GTQ'},
  {id: 'GU', name: 'Guam', currency: 'USD'},
  {id: 'GW', name: 'Guinea-Bissau', currency: 'XOF'},
  {id: 'GY', name: 'Guyana', currency: 'GYD'},
  {id: 'HK', name: 'Hong Kong', currency: 'HKD'},
  {id: 'HM', name: 'Heard Island and McDonald Islands', currency: 'AUD'},
  {id: 'HN', name: 'Honduras', currency: 'HNL'},
  {id: 'HR', name: 'Croatia', currency: 'EUR'},
  {id: 'HT', name: 'Haiti', currency: 'HTG'},
  {id: 'HU', name: 'Hungary', currency: 'HUF'},
  {id: 'ID', name: 'Indonesia', currency: 'IDR'},
  {id: 'IE', name: 'Ireland', currency: 'EUR'},
  {id: 'IL', name: 'Israel', currency: 'ILS'},
  {id: 'IM', name: 'Isle of Man', currency: 'GBP'},
  {id: 'IN', name: 'India', currency: 'INR'},
  {
    id: 'IO',
    name: 'British Indian Ocean Territory',
    currency: 'USD',
  },
  {id: 'IQ', name: 'Iraq', currency: 'IQD'},
  {id: 'IR', name: 'Iran', currency: 'IRR'},
  {id: 'IS', name: 'Iceland', currency: 'ISK'},
  {id: 'IT', name: 'Italy', currency: 'EUR'},
  {id: 'JE', name: 'Jersey', currency: 'GBP'},
  {id: 'JM', name: 'Jamaica', currency: 'JMD'},
  {id: 'JO', name: 'Jordan', currency: 'JOD'},
  {id: 'JP', name: 'Japan', currency: 'JPY'},
  {id: 'KE', name: 'Kenya', currency: 'KES'},
  {id: 'KG', name: 'Kyrgyzstan', currency: 'KGS'},
  {id: 'KH', name: 'Cambodia', currency: 'KHR'},
  {id: 'KI', name: 'Kiribati', currency: 'AUD'},
  {id: 'KM', name: 'Comoros', currency: 'KMF'},
  {id: 'KN', name: 'Saint Kitts and Nevis', currency: 'XCD'},
  {id: 'KP', name: 'North Korea', currency: 'KPW'},
  {id: 'KR', name: 'South Korea', currency: 'KRW'},
  {id: 'KW', name: 'Kuwait', currency: 'KWD'},
  {id: 'KY', name: 'Cayman Islands', currency: 'KYD'},
  {id: 'KZ', name: 'Kazakhstan', currency: 'KZT'},
  {id: 'LA', name: 'Laos', currency: 'LAK'},
  {id: 'LB', name: 'Lebanon', currency: 'LBP'},
  {id: 'LC', name: 'Saint Lucia', currency: 'XCD'},
  {id: 'LI', name: 'Liechtenstein', currency: 'CHF'},
  {id: 'LK', name: 'Sri Lanka', currency: 'LKR'},
  {id: 'LR', name: 'Liberia', currency: 'LRD'},
  {id: 'LS', name: 'Lesotho', currency: 'LSL'},
  {id: 'LT', name: 'Lithuania', currency: 'EUR'},
  {id: 'LU', name: 'Luxembourg', currency: 'EUR'},
  {id: 'LV', name: 'Latvia', currency: 'EUR'},
  {id: 'LY', name: 'Libya', currency: 'LYD'},
  {id: 'MA', name: 'Morocco', currency: 'MAD'},
  {id: 'MC', name: 'Monaco', currency: 'EUR'},
  {id: 'MD', name: 'Moldova', currency: 'MDL'},
  {id: 'ME', name: 'Montenegro', currency: 'EUR'},
  {id: 'MF', name: 'Saint Martin', currency: 'EUR'},
  {id: 'MG', name: 'Madagascar', currency: 'MGA'},
  {id: 'MH', name: 'Marshall Islands', currency: 'USD'},
  {id: 'MK', name: 'North Macedonia', currency: 'MKD'},
  {id: 'ML', name: 'Mali', currency: 'XOF'},
  {id: 'MM', name: 'Myanmar [Burma]', currency: 'MMK'},
  {id: 'MN', name: 'Mongolia', currency: 'MNT'},
  {id: 'MO', name: 'Macao', currency: 'MOP'},
  {id: 'MP', name: 'Northern Mariana Islands', currency: 'USD'},
  {id: 'MQ', name: 'Martinique', currency: 'EUR'},
  {id: 'MR', name: 'Mauritania', currency: 'MRU'},
  {id: 'MS', name: 'Montserrat', currency: 'XCD'},
  {id: 'MT', name: 'Malta', currency: 'EUR'},
  {id: 'MU', name: 'Mauritius', currency: 'MUR'},
  {id: 'MV', name: 'Maldives', currency: 'MVR'},
  {id: 'MW', name: 'Malawi', currency: 'MWK'},
  {id: 'MX', name: 'Mexico', currency: 'MXN'},
  {id: 'MY', name: 'Malaysia', currency: 'MYR'},
  {id: 'MZ', name: 'Mozambique', currency: 'MZN'},
  {id: 'NA', name: 'Namibia', currency: 'NAD'},
  {id: 'NC', name: 'New Caledonia', currency: 'XPF'},
  {id: 'NE', name: 'Niger', currency: 'XOF'},
  {id: 'NF', name: 'Norfolk Island', currency: 'AUD'},
  {id: 'NG', name: 'Nigeria', currency: 'NGN'},
  {id: 'NI', name: 'Nicaragua', currency: 'NIO'},
  {id: 'NL', name: 'Netherlands', currency: 'EUR'},
  {id: 'NO', name: 'Norway', currency: 'NOK'},
  {id: 'NP', name: 'Nepal', currency: 'NPR'},
  {id: 'NR', name: 'Nauru', currency: 'AUD'},
  {id: 'NU', name: 'Niue', currency: 'NZD'},
  {id: 'NZ', name: 'New Zealand', currency: 'NZD'},
  {id: 'OM', name: 'Oman', currency: 'OMR'},
  {id: 'PA', name: 'Panama', currency: 'PAB'},
  {id: 'PE', name: 'Peru', currency: 'PEN'},
  {id: 'PF', name: 'French Polynesia', currency: 'XPF'},
  {id: 'PG', name: 'Papua New Guinea', currency: 'PGK'},
  {id: 'PH', name: 'Philippines', currency: 'PHP'},
  {id: 'PK', name: 'Pakistan', currency: 'PKR'},
  {id: 'PL', name: 'Poland', currency: 'PLN'},
  {id: 'PM', name: 'Saint Pierre and Miquelon', currency: 'EUR'},
  {id: 'PN', name: 'Pitcairn Islands', currency: 'NZD'},
  {id: 'PR', name: 'Puerto Rico', currency: 'USD'},
  {id: 'PS', name: 'Palestine', currency: 'ILS'},
  {id: 'PT', name: 'Portugal', currency: 'EUR'},
  {id: 'PW', name: 'Palau', currency: 'USD'},
  {id: 'PY', name: 'Paraguay', currency: 'PYG'},
  {id: 'QA', name: 'Qatar', currency: 'QAR'},
  {id: 'RE', name: 'Réunion', currency: 'EUR'},
  {id: 'RO', name: 'Romania', currency: 'RON'},
  {id: 'RS', name: 'Serbia', currency: 'RSD'},
  {id: 'RU', name: 'Russia', currency: 'RUB'},
  {id: 'RW', name: 'Rwanda', currency: 'RWF'},
  {id: 'SA', name: 'Saudi Arabia', currency: 'SAR'},
  {id: 'SB', name: 'Solomon Islands', currency: 'SBD'},
  {id: 'SC', name: 'Seychelles', currency: 'SCR'},
  {id: 'SD', name: 'Sudan', currency: 'SDG'},
  {id: 'SE', name: 'Sweden', currency: 'SEK'},
  {id: 'SG', name: 'Singapore', currency: 'SGD'},
  {id: 'SH', name: 'Saint Helena', currency: 'SHP'},
  {id: 'SI', name: 'Slovenia', currency: 'EUR'},
  {id: 'SJ', name: 'Svalbard and Jan Mayen', currency: 'NOK'},
  {id: 'SK', name: 'Slovakia', currency: 'EUR'},
  {id: 'SL', name: 'Sierra Leone', currency: 'SLE'},
  {id: 'SM', name: 'San Marino', currency: 'EUR'},
  {id: 'SN', name: 'Senegal', currency: 'XOF'},
  {id: 'SO', name: 'Somalia', currency: 'SOS'},
  {id: 'SR', name: 'Suriname', currency: 'SRD'},
  {id: 'SS', name: 'South Sudan', currency: 'SSP'},
  {id: 'ST', name: 'São Tomé and Príncipe', currency: 'STN'},
  {id: 'SV', name: 'El Salvador', currency: 'USD'},
  {id: 'SX', name: 'Sint Maarten', currency: 'ANG'},
  {id: 'SY', name: 'Syria', currency: 'SYP'},
  {id: 'SZ', name: 'Swaziland', currency: 'SZL'},
  {id: 'TC', name: 'Turks and Caicos Islands', currency: 'USD'},
  {id: 'TD', name: 'Chad', currency: 'XAF'},
  {id: 'TF', name: 'French Southern Territories', currency: 'EUR'},
  {id: 'TG', name: 'Togo', currency: 'XOF'},
  {id: 'TH', name: 'Thailand', currency: 'THB'},
  {id: 'TJ', name: 'Tajikistan', currency: 'TJS'},
  {id: 'TK', name: 'Tokelau', currency: 'NZD'},
  {id: 'TL', name: 'East Timor', currency: 'USD'},
  {id: 'TM', name: 'Turkmenistan', currency: 'TMT'},
  {id: 'TN', name: 'Tunisia', currency: 'TND'},
  {id: 'TO', name: 'Tonga', currency: 'TOP'},
  {id: 'TR', name: 'Turkey', currency: 'TRY'},
  {id: 'TT', name: 'Trinidad and Tobago', currency: 'TTD'},
  {id: 'TV', name: 'Tuvalu', currency: 'AUD'},
  {id: 'TW', name: 'Taiwan', currency: 'TWD'},
  {id: 'TZ', name: 'Tanzania', currency: 'TZS'},
  {id: 'UA', name: 'Ukraine', currency: 'UAH'},
  {id: 'UG', name: 'Uganda', currency: 'UGX'},
  {id: 'UM', name: 'U.S. Minor Outlying Islands', currency: 'USD'},
  {id: 'US', name: 'United States', currency: 'USD'},
  {id: 'UY', name: 'Uruguay', currency: 'UYU'},
  {id: 'UZ', name: 'Uzbekistan', currency: 'UZS'},
  {id: 'VA', name: 'Vatican City', currency: 'EUR'},
  {id: 'VC', name: 'Saint Vincent and the Grenadines', currency: 'XCD'},
  {id: 'VE', name: 'Venezuela', currency: 'VES'},
  {id: 'VG', name: 'British Virgin Islands', currency: 'USD'},
  {id: 'VI', name: 'U.S. Virgin Islands', currency: 'USD'},
  {id: 'VN', name: 'Vietnam', currency: 'VND'},
  {id: 'VU', name: 'Vanuatu', currency: 'VUV'},
  {id: 'WF', name: 'Wallis and Futuna', currency: 'XPF'},
  {id: 'WS', name: 'Samoa', currency: 'WST'},
  {id: 'XK', name: 'Kosovo', currency: 'EUR'},
  {id: 'YE', name: 'Yemen', currency: 'YER'},
  {id: 'YT', name: 'Mayotte', currency: 'EUR'},
  {id: 'ZA', name: 'South Africa', currency: 'ZAR'},
  {id: 'ZM', name: 'Zambia', currency: 'ZMW'},
  {id: 'ZW', name: 'Zimbabwe', currency: 'ZWL'},
];
